/**
 *
 * QuestionMatrixRow
 *
 */

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Markdown from 'marked-react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import FormControlOption from './components/FormControlOption';

const useStyles = makeStyles({
  group: {
    margin: '8px 0',
  },
  matrixQuestion: {
    marginTop: 16,
    fontSize: 16,
    fontWeight: 'bold',
    position: 'relative',
  },
});

function QuestionMatrixRow({
  columns,
  row,
  onChange,
  isMobile,
  answers,
  error,
}) {
  const classes = useStyles();
  const [hasChanged, setChanged] = useState(false);

  const handleChange = e => {
    setChanged(true);
    onChange(e);
  };

  if (isMobile)
    return (
      <>
        <Typography className={classes.matrixQuestion} id={`q-${row.value}`}>
          - {<Markdown isInline>{row.text}</Markdown>}
          {!hasChanged && error.includes(row.value) && (
            <span className="pulsating-circle matrix-mobile" />
          )}
        </Typography>
        <RadioGroup
          aria-label={row.text}
          name={row.text}
          className={classes.group}
          onChange={handleChange}
        >
          {columns.map(col => {
            let checked = false;
            if (answers && answers[row.value] === col.value) checked = true;
            return (
              <FormControlOption
                key={`ROW-${row.value}-COL-${col.value}`}
                value={col.value}
                checked={checked}
                label={<Markdown isInline>{col.text}</Markdown>}
                type="radio"
              />
            );
          })}
        </RadioGroup>
      </>
    );

  return (
    <tr key={`ROW-${row.value}`} id={`q-${row.value}`}>
      <td>
        <div>
          {<Markdown isInline>{row.text}</Markdown>}
          {!hasChanged && error.includes(row.value) && (
            <span className="pulsating-circle" />
          )}
        </div>
      </td>
      {columns.map(col => {
        let checked = false;
        if (answers && answers[row.value] === col.value) checked = true;
        return (
          <td key={`ROW-${row.value}-COL-${col.value}`}>
            <Radio
              color="primary"
              checked={checked}
              value={col.value}
              onChange={handleChange}
              inputProps={{ 'aria-label': `Radio ${row.value}` }}
            />
          </td>
        );
      })}
    </tr>
  );
}

QuestionMatrixRow.propTypes = {
  columns: PropTypes.array,
  row: PropTypes.object,
  onChange: PropTypes.func,
  isMobile: PropTypes.bool,
  answers: PropTypes.object,
  error: PropTypes.array,
};

export default QuestionMatrixRow;
